import script from "./VmdReq.vue?vue&type=script&setup=true&lang=js"
export * from "./VmdReq.vue?vue&type=script&setup=true&lang=js"

import "./VmdReq.vue?vue&type=style&index=0&id=aa2d97e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa2d97e4"]])

export default __exports__